import React from "react";
import "../css/Toolbox.css";
import toolbox from "../data/toolbox.data";

const groups = ["All", "Backend", "Frontend", "Data", "DevOps / Workflow"];

export default function Toolbox() {
  const [active, setActive] = React.useState("All");
  const items = active === "All" ? toolbox : toolbox.filter((t) => t.group === active);

  return (
    <section className="toolbox" id="toolbox">
      <header className="toolboxHeader">
        <p className="toolboxSub">Tools I use to ship real systems.</p>
        <div className="toolboxFilters" aria-label="Filter tools by category">
          {groups.map((group) => (
            <button
              key={group}
              type="button"
              className={`filterBtn ${active === group ? "isActive" : ""}`}
              onClick={() => setActive(group)}
            >
              {group}
            </button>
          ))}
        </div>
      </header>

      <div className="toolboxGrid">
        {items.map((tool) => (
          <div className="toolCard" key={`${tool.group}-${tool.name}`}>
            {tool.icon ? (
              <div
                className="toolIcon"
                dangerouslySetInnerHTML={{ __html: tool.icon }}
              />
            ) : (
              <img src={tool.logo} alt={tool.name} loading="lazy" />
            )}
            <span>{tool.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
